'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Step = require('./Step.js');
var mockData = require('../../mockData.js');
var index = require('../../packs/OrderLookup/index.js');
var index$1 = require('../../packs/ItemSelector/index.js');
require('@babel/runtime/helpers/extends');
require('../../packs/ReturnReasons/ReturnReasonsRaw.js');
require('react-query');
require('@narvar/nth-hook-loma');
require('@narvar/nth-hook-global-settings');
require('@narvar/nth-bit-error-boundary');
require('@apollo/client');
require('@apollo/client/link/error');
require('@narvar/apollo-client');
require('@narvar/nth-hook-translations');
require('@narvar/nth-hook-settings');
require('@narvar/nth-hook-theme');
require('@narvar/nth-hook-context-analytics');
require('jwt-decode');
require('../../packs/Pudo/RootElm/PudoRaw.js');
var wrapped = require('../../packs/Pudo/RootElm/wrapped.js');
var index$2 = require('../../packs/ReviewSummary/index.js');
require('../../packs/Confirmation/raw.js');
require('../../packs/RefundMethods/raw.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ProgressiveReturnWizard = () => {
  const [step, setStep] = React.useState(0);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "container mx-auto flex gap-y-4 flex-col"
  }, "Narvar Progressive Return Wizard", /*#__PURE__*/React__default["default"].createElement(Step["default"], null, /*#__PURE__*/React__default["default"].createElement(index.OrderLookup, {
    onSubmit: () => setStep(1),
    progressiveStep: true,
    activeStep: step === 0
  })), step >= 1 && /*#__PURE__*/React__default["default"].createElement(Step["default"], null, /*#__PURE__*/React__default["default"].createElement(index$1.ItemSelector, {
    allItems: mockData.mockOrderItems,
    onSubmit: () => setStep(2),
    progressiveStep: true,
    activeStep: step === 1
  })), step >= 2 && /*#__PURE__*/React__default["default"].createElement(Step["default"], null, /*#__PURE__*/React__default["default"].createElement(wrapped.Pudo, {
    onSubmit: () => setStep(3),
    progressiveStep: true,
    activeStep: step === 2
  })), step >= 3 && /*#__PURE__*/React__default["default"].createElement(Step["default"], null, /*#__PURE__*/React__default["default"].createElement(index$2.ReviewSummary, {
    onSubmit: () => setStep(4),
    progressiveStep: true,
    activeStep: step === 3
  })), step >= 4 && /*#__PURE__*/React__default["default"].createElement(Step["default"], null, "Return submitted"));
};

exports["default"] = ProgressiveReturnWizard;
